var _ = require('lodash');
var config = process.env.BROWSER ? require('cfg').default : require('config');
var TemplateConstants = require('./TemplateConstants.js');

module.exports = {
    // @deprecated
    titleFontFamily: '"Roboto", sans-serif',
    // @deprecated
    fontFamily: '"Roboto", sans-serif',
    // @deprecated
    shirtNumbersFontFamily: 'BenchNine',
    // @deprecated
    googleFontName: 'Roboto',

    teamLogo: 'logo', // empty, invisible, logo, tshirt, 3d-tshirt

    fonts: {
        main: _.clone(TemplateConstants.FONT),
        title: {
            ..._.clone(TemplateConstants.FONT),
            fontSize: 32,
        },
        subTitle: {
            fontSize: 18,
        },
        shirtNumber: {
            name: 'BenchNine',
            fontFamily: '"BenchNine", sans-serif',
            fontStyle: 'normal',
            thin: 400,
            normal: 400,
            bold: 400,
            textTransform: '',
            gFontName: 'BenchNine',
            gWeights: '400',
            gSubsets: '',
        },
        special: _.clone(TemplateConstants.FONT),
    },

    color: '#fff',
    titleColor: '#fff',
    subTitleColor: '#fff',
    split: 'vertical',
    weight: 0.5,
    direction: 'row',

    primaryColor: '#d8005f',
    primaryTextColor: '#fff',

    statColorHome: '#00589d',
    statColorNeutral: '#ccc',
    statColorAway: '#08abd4',

    statTableBgColor: 'rgba(255,255,255,0.9)',
    statTableTextColor: 'rgba(0,0,0,1.0)',
    statTableLabelTextColor: 'rgba(0,0,0,1.0)',
    statTextColor: 'rgba(255,255,255,0.9)',

    positiveColor: '#08e965',
    negativeColor: '#F44336',
    substitutionOutColor: '#FA070C',
    minHeight: 'auto',
    brandingBackground: 'rgba(255,255,255,0)',

    // whaat
    logosBackground: 'rgba(255,255,255,0.7)',

    containerPadding: 0, // @deprecated
    contentPadding: 30, // @deprecated
    teamBackgroundColor: '',
    teamColor: '',
    preview: {
        fullSize: true,
        backgroundImage: `${config.assets}/assets/sm_cover.png`,
        backgroundPositionX: 50,
        backgroundPositionY: 50,
    },
    preview_overlay: {
        startColor: 'rgba(0,0,0,0.1)',
        endColor: 'rgba(0,0,0,0.3)',
        gradient: 'none',
        position: 'to top right',
    },
    widgets: {},
    widgetsColors: {
        widgetId: {
            class: 'color',
        },
    },
    layers: [TemplateConstants.LAYER],
    content: {
        backgroundColor: 'rgba(0,0,0,0.5)',
        accentColor: '#0db4e7',
        accentTextColor: '#fff',
        accent2Color: '#0db4e7',
        accent2TextColor: '#fff',
        minHeight: 500,
        valign: 'top',
        margin: '0 0 0 0',
        padding: '0 0 0 0',
        fillColor: 'transparent',
        gradientAlign: 'left',
        gradientWidth: '100',
        gradientHeight: '100',
    },
    layer: {},
    pitch: {
        lines: '#8AD58A',
        stripes: '#fff',
        background: '#2A8337',
        bottomBorder: '#1C2806',
    },
    wdl: {
        win: '#2ec62a', //TODO: ADD THIS VARIABLE TO THE EDITOR
        draw: '#757575', //TODO: ADD THIS VARIABLE TO THE EDITOR
        loss: '#df3746', //TODO: ADD THIS VARIABLE TO THE EDITOR,
        notPlayed: '#c4c4c4', //TODO: ADD THIS VARIABLE TO THE EDITOR,
    },
    qualRelColors: {
        leagueWinner: '#F12A09',
        championsleague: '#08abd4',
        championsleaguequal: '#08abd4',
        uefacup: '#ff0000',
        uefaqual: '#08abd4',
        relegation: '#f57005',
        promotion: '#08abd4',
        promotionplayoff: '#08abd4',
        qualification_to_next_stage: '#08abd4',
        championship_playoff: '#08abd4',
        relegationplayoff: '#f57005',
        uefaqualplayoff: '#08abd4',
    },
    brandingProps: TemplateConstants.BRANDING,
    defaultBranding: {
        brandingSecondary: 'visit superliga.dk',
        brandingPrimary: 'alka',
    },
    display: {
        title: 'default',
        playersList: 'default',
        matchCell: 'default',
        tournamentTable: 'default',
        incidentCard: 'default',
        playerLogo: 'default',
        h2hTable: 'default',
        flag: 'default',
    },

    radar: {
        strokeColorHome: 'rgba(20, 216, 255, 1)',
        strokeColorAway: 'rgba(165, 253, 0, 1)',
        strokeColorOpponent: 'rgba(115, 255, 192, 1)',
        fillColorHome: 'rgba(20, 216, 255, 0.1)',
        fillColorAway: 'rgba(165, 253, 0, 0.1)',
        fillColorOpponent: 'rgba(115, 255, 192, 1)',
        chartBorderColor: 'rgba(252, 251, 255, 0.35)',
        polygonBorderColor: 'rgba(255, 255, 255, 0.35)',
        labelTextColor: 'rgba(255, 255, 255, 1)',
        polygonBgColor: 'rgba(18, 29, 84, 0.5)',
    },
    f1: {
        primaryColor: '#fd2c17',
        primaryTextColor: '#fff',
        headerBgColor: '#2c2c2c',
        headerTextColor: '#fff',
        tableBgColor: '#fff',
        tableTextColor: '#000',
        tableSecondaryTextColor: '#333',
        primaryCellColor: '#FD2C17',
        secondaryCellColor: '#6A6A6A',
        primaryCellTextColor: '#6A6A6A',
        secondaryCellTextColor: '#000000',
        inprogress: '#03cc27',
        finished: '#2c2c2c',
        notstarted: '#2c2c2c',
        trackLineColor: '#FB251D',
        trackMapDetails: '#ccc',
        trackDrsColor: '#fff',
    },
    skins: {
        skew: {
            angle: 5,
        },
    },
    dateFormats: {
        TIME: 'HH:mm',
        DATE_AND_TIME_SHORT: 'DD MM, HH:mm',
        DATE_AND_TIME_FULL: 'DD MMMM, HH:mm',
        DATE: 'DD MMMM',
        DATE_SHORT: 'D MMM',
        DATE_WEEKDAY: 'dddd, D MMMM',
    },
    oddsFormat: 'decimal', // fractional
};

//h:mm A Do MMMM



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/templates/SplitImageTPLDefaultTheme.js
 **/